class SideMenu {
  el;
  buttonOpen;
  buttonClose;

  constructor(sideMenu) {
    this.el = sideMenu;
    this.buttonOpen = document.querySelector(".button-side-menu");
    this.buttonClose = this.el.querySelector(".button-close");

    this.bindListeners();
  }

  bindListeners() {
    this.buttonOpen.addEventListener("click", this.open.bind(this));
    this.buttonClose.addEventListener("click", this.close.bind(this));
  }

  open() {
    this.el.classList.add("open");
  }

  close() {
    this.el.classList.remove("open");
  }
}

const sideMenu = document.querySelector(".js-side-menu");
if (sideMenu) {
  new SideMenu(sideMenu);
}
